module.exports = __webpack_public_path__ + "img/rosspiece.9a531e41.png";